import { createFileRoute } from '@tanstack/react-router';
import { ShipmentsOverviewLayout } from '@uturn/portal/modules/shipments';

export const Route = createFileRoute('/_protected/shipments/(overview)')({
	component: ShipmentsOverviewLayout,
});
